/** Basit Sorgu — çift katman stroke, filter yok */
import { QUERY_ICON_BASIC } from './queryIconNeon.jsx';

function BasicQueryPaths({ stroke, sw, swBold, swDetail, accentW, accentStroke, strokeOpacity }) {
  const op = strokeOpacity != null ? { strokeOpacity } : {};
  return (
    <>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={sw} {...op}>
        <path d="M94 310 L256 226 L418 310 L256 394 Z" />
        <path d="M94 310 L94 338 L256 424 L418 338 L418 310" />
        <path d="M173 269 L337 354" />
        <path d="M256 226 L256 394" />
        <path d="M337 269 L173 354" />
        <path d="M138 333 L303 248" />
        <path d="M209 371 L374 286" />
      </g>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={swBold} {...op}>
        <path d="M256 76 C194 76 144 126 144 188 C144 278 256 354 256 354 C256 354 368 278 368 188 C368 126 318 76 256 76 Z" />
        <circle cx="256" cy="188" r="42" />
      </g>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={swDetail} {...op}>
        <path d="M142 260 V214" />
        <circle cx="142" cy="214" r="8" />
        <path d="M388 284 V232" />
        <circle cx="388" cy="232" r="8" />
      </g>
      <g stroke={accentStroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={accentW} {...op}>
        <path d="M106 202 H142" />
        <path d="M370 204 H408" />
        <path d="M80 250 H112" />
        <path d="M398 258 H432" />
      </g>
    </>
  );
}

export function BasicQueryIcon() {
  const c = QUERY_ICON_BASIC;
  const sw = 30;
  const swBold = 38;
  const swDetail = 24;
  const accentW = 12;
  const glowExtra = 8;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="none"
      aria-hidden="true"
      focusable="false"
      shapeRendering="geometricPrecision"
    >
      <BasicQueryPaths
        stroke={c.glow}
        strokeOpacity={0.38}
        sw={sw + glowExtra}
        swBold={swBold + glowExtra}
        swDetail={swDetail + glowExtra}
        accentW={accentW + 4}
        accentStroke={c.glow}
      />
      <BasicQueryPaths
        stroke={c.core}
        sw={sw}
        swBold={swBold}
        swDetail={swDetail}
        accentW={accentW}
        accentStroke={c.accent}
      />
    </svg>
  );
}
